import { SVGProps } from 'react';

const Cross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    stroke="#A0A8AA"
    {...props}
  >
    <path
      stroke="current"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.333 6.667-6.667 6.666m0-6.667 6.667 6.667"
    />
  </svg>
);
export default Cross;
